import { render, staticRenderFns } from "./shengchan.vue?vue&type=template&id=3b0c6de7&scoped=true&"
import script from "./shengchan.vue?vue&type=script&lang=js&"
export * from "./shengchan.vue?vue&type=script&lang=js&"
import style0 from "./shengchan.vue?vue&type=style&index=0&id=3b0c6de7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0c6de7",
  null
  
)

component.options.__file = "shengchan.vue"
export default component.exports